import { makeAutoObservable } from 'mobx';
import { trackAssetsFlatViewToggle } from 'src/services/tracker/trackers/assets';
import AuthenticationStore from './AuthenticationStore';
import { RootStoreSerialization } from './types';
import FilterStore, { FilterState } from './FilterStore';
import NavigationPanelStore from './NavigationPanelStore';

export type PersistableRootStore = {
	serializationToPersist: () => object;
	rehydrateWithSerialization: ( serialization: object ) => void;
};

type RootStoreParams = {
	isAuthenticated?: boolean;
	filterState?: FilterState;
};

export class RootStore implements PersistableRootStore {
	authenticationStore: AuthenticationStore;
	filterStore: FilterStore;
	navigationPanelStore: NavigationPanelStore;
	assetsFlatViewEnabled = false;

	constructor( { isAuthenticated, filterState }: RootStoreParams = {} ) {
		this.authenticationStore = new AuthenticationStore( isAuthenticated );
		this.filterStore = new FilterStore( filterState );
		this.navigationPanelStore = new NavigationPanelStore();

		makeAutoObservable( this );
	}

	get isAuthenticated() {
		return this.authenticationStore.isAuthenticated;
	}

	toggleAssetsFlatView = () => {
		this.assetsFlatViewEnabled = !this.assetsFlatViewEnabled;
		trackAssetsFlatViewToggle( { enabled: this.assetsFlatViewEnabled } );
	}

	serializationToPersist(): RootStoreSerialization {
		return {
			authenticationStore: this.authenticationStore.serialize(),
			filterStore: this.filterStore.serialize(),
			navigationPanelStore: this.navigationPanelStore.serialize()
		};
	}

	rehydrateWithSerialization( { authenticationStore, filterStore, navigationPanelStore }: RootStoreSerialization ) {
		if ( authenticationStore ) {
			this.authenticationStore.hydrate( authenticationStore );
		}

		if ( filterStore ) {
			this.filterStore.hydrate( filterStore );
		}

		if ( navigationPanelStore ) {
			this.navigationPanelStore.hydrate( navigationPanelStore );
		}
	}

	clearStore() {
		this.authenticationStore.clear();
		this.filterStore.clear();
		this.navigationPanelStore.clear();
		this.assetsFlatViewEnabled = false;
	}
}
